const walker = document.createTreeWalker(
  document.body,
  NodeFilter.SHOW_TEXT
);

const nodes = [];

while (walker.nextNode()) {
  if (/™|®/.test(walker.currentNode.nodeValue)) {
    nodes.push(walker.currentNode);
  }
}

nodes.forEach(node => {
  const fragment = document.createDocumentFragment();
  const parts = node.nodeValue.split(/(™|®)/g);

  parts.forEach(part => {
    if (part === '™' || part === '®') {
      const sub = document.createElement('sup');
      sub.textContent = part;
      fragment.appendChild(sub);
    } else if (part) {
      fragment.appendChild(document.createTextNode(part));
    }
  });

  node.parentNode.replaceChild(fragment, node);
});

const element = document.querySelector('#MainContent .shopify-section:nth-child(2) .page-width.relative');

if (element) {
  element.id = 'learn-more';
}

(function () {
    document.querySelector('a.button.button--primary.button--lg.size-style:last-child').addEventListener('click', function (e) {
        e.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        this.blur();

        document.querySelector('.topbar__left-shipping.flex.items-center.gap-2')?.focus();
    });
})();